var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-5"},[_c('p',[_vm._v("Sorry!! The requested content is not available for you.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to Home!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }